import axios from "axios"
import store from "@/store"
import router from "@/router"
import * as Cookies from "js-cookie"
import Vue from "vue"

export default () => {
    var customAxios = axios.create({
        baseURL: process.env.VUE_APP_BASE_URL,
        withCredentials: true
        // headers: {
        //     Accept: "application/json"
        //    // 'Content-Type': 'application/json'
        // }
    })

    const bearerToken = Cookies.get("bearer_token")
    if (bearerToken) {
        customAxios.defaults.headers.common["Authorization"] = "Bearer " + bearerToken
    }

    customAxios.interceptors.response.use(
        response => {
            return response
        },

        error => {
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        store.dispatch("LOGOUT")
                        Vue.notify({
                            group: "auth",
                            type: "error",
                            title: "Autenticación",
                            text: "Usuario/Contraseña incorrecto, debe autenticarse nuevamente"
                        })
                        router.push("/login")
                        break
                    case 500:
                        Vue.notify({
                            group: "auth",
                            type: "error",
                            title: "Servidor",
                            text: "Error interno del servidor, inténtelo otra vez"
                        })
                        break
                    case 404:
                        Vue.notify({
                            group: "auth",
                            type: "error",
                            title: "Servidor",
                            text: "El elemento que intenta obtener no existe"
                        })
                        break
                    case 403:
                        router.push("/403")
                        break
                }
                return Promise.reject(error)
            }
        }
    )

    return customAxios
}
